(function(angular) {
    var _dispositionService;
    var _feedModel;
    var _channelModel;
    var _muteService;
    var _endpointModel;
    var _calls = {};

    function setPhoneDisposition(endpointId) {
        _dispositionService.setDisposition(endpointId, 'Phone');
    }

    function setReadyDisposition(endpointId) {
        _dispositionService.setDisposition(endpointId, 'Ready');
    }

    function endCall(call) {
        if (call) {
            let channel = _channelModel.getChannel(call.channelId);
            _feedModel.addChannelFeedEvent(call.channelId, '', 'call-ended', '');
            call.isActive = false;
            channel.callActive = false;
            _muteService.restoreTempMute();
            setReadyDisposition(_endpointModel.getMyEndpoint().id);
        }
    }

    class PrivateCallService {
        constructor(
            $rootScope,
            $q,
            $log,
            $timeout,
            wtcpjsClientProviderService,
            muteService,
            endpointModel,
            channelModel,
            feedModel,
            dispositionService,
            userService) {
            this.activationStatus = {'Pending': 1, 'Active': 2, 'Error': 3};
            this.$rootScope = $rootScope;
            this.$q = $q;
            this.$log = $log;
            _channelModel = channelModel;
            _endpointModel = endpointModel;
            _feedModel = feedModel;
            _muteService = muteService;
            _calls = {};
            this.client = wtcpjsClientProviderService.getClient();
            this.phoneLine = {status: 0, statusMessage: '', number: ''};
            this.activeCallOffer = null;
            this.activeCall = null;
            _dispositionService = dispositionService;

            var privateCallChannelFilterId = wtcpjsClientProviderService.filterTypes.privateCallChannelFilter;
            var spcFilterActive = false;

            this.numberCallIdMap = {};

            function notifyCallofferReceived(d) {
                $rootScope.$broadcast('privateCallService.callOfferReceived', d);
            }

            function isRadioUser(user) {
                return user.endpoints.length > 0 && user.endpoints[0].participantType === 'RADIO';
            }

            this.activeCallExists = () => {
                return this.activeCall && this.activeCall.isActive;
            };

            this.callOfferFromUserExists = (userName) => {
                return this.activeCallOffer && this.activeCallOffer.endpointPropertyInfo.endpointInfo.endpointName === userName;
            };

            /* Error states */
            this.noCallResource = false;
            this.invalidPhoneLine = false;

            this.createParticipantFilter = function (pcChan) {

                if (pcChan.participantId) {
                    var myEndpoint = endpointModel.getMyEndpoint();
                    let p1 = pcChan.participantId.replace('{', '\\{').replace('}', '\\}');
                    let p2 = myEndpoint.userName.replace('{', '\\{').replace('}', '\\}');
                    this.client.setEndpointSPCFilter(privateCallChannelFilterId, 0, {'userName': `^${p1}\$|^${p2}\$`}, "*", 0, new WtcpJs.AnchorInfo())
                        .then((resp) => {
                            spcFilterActive = true;
                            $log.debug("private call endpoint callee retrieved", resp);

                            endpointModel.initializeEndpoints(pcChan.id, resp);

                            /*this.client.setEndpointSPCFilter(privateCallChannelSelfFilterId, 0, {'userName': myEndpoint.userName}, '*', 0, new WtcpJs.AnchorInfo())
                                .then((myResp) => {
                                    Array.prototype.push.apply(resp.endpointPropertyInfo, myResp.endpointPropertyInfo);
                                    endpointModel.initializeEndpoints(pcChan.id, resp);
                                })
                                .catch((err) => {
                                    $log.error("There was an error filtering on your endpoint", err);
                                });*/
                        })
                        .catch((err) => {
                            $log.error("There was an error trying to retrieve the participant", err);
                        });
                }
            }

            this.privateCall = (callId, number) => {

                this.numberCallIdMap[number] = callId;
                return _calls[callId] = {callId, callAlias: number, isActive: true, channelId: 0};
            };

            var unbindChannelSelected = $rootScope.$on('channelModel.channelSelected', (e, channel) => {
                if (channel.id > 0 && spcFilterActive) {
                    this.client.clearEndpointFilter(privateCallChannelFilterId)
                        .then(() => {
                            spcFilterActive = false;
                        })
                        .catch((err) => {
                            $log.error('An error occurred while trying to clear the private call channel filter', err);
                        });
                } else {
                    this.createParticipantFilter(channel);
                }
            });

            var unbindLogout = $rootScope.$on('ConnectionService.logout', () => {
                _calls = {};
                this.numberCallIdMap = {};
                this.activeCall = null;
                spcFilterActive = false;
            });

            var unbindReconnect = $rootScope.$on('isReconnecting', (e, reconnect, epId) => {
                var c;
                if (reconnect) {
                    channelModel.getActiveChannelIds().forEach((key) => {
                        c = channelModel.getChannel(key);
                        if (c.callActive) {
                            c.callActive = false;
                            feedModel.addChannelFeedEvent(this.activeCall.channelId, '', 'call-ended', '');
                            this.activeCall.isActive = false;
                            this.activeCall =  null;
                        }
                    });

                    _calls = {};
                    this.numberCallIdMap = {};
                } else if(epId) {
                    muteService.restoreTempMute();
                    c = channelModel.getSelectedChannel();

                    if(c && c.id < 0) {
                        this.createParticipantFilter(c);
                    } else {
                        spcFilterActive = false;
                    }
                }
            });

            var onPhoneLineStatusChanged = this.client.onPhoneLineStatusChanged.subscribe((d) => {
                let pcs = this;
                $rootScope.$applyAsync(function ($scope) {
                    if (d.errorCode === 0) {
                        pcs.phoneLine.status = pcs.activationStatus.Active;
                        pcs.phoneLine.statusMessage = 'Ready';
                    } else {
                        pcs.phoneLine.status = pcs.activationStatus.Error;
                        pcs.phoneLine.statusMessage = d.errorMessage;
                    }
                });
            });

            var onCallProgressRecieved = this.client.onCallProgressReceived.subscribe((d) => {
                let pcs = this;
                $rootScope.$applyAsync(function () {
                    $log.info('call progress received from Proxy', d);
                    // CALL_STATE: 1 -> proceeding
                    //             2 -> ringing
                    //             3 -> connected

                    if (d.callState === 3) {
                        try {
                            let channel = channelModel.getChannel(_calls[d.callId].channelId);

                            if (!pcs.activeCallOffer) {
                                // See TBD section of onCallOfferReceived for why this is necessary
                                if(!channel.participantId) {
                                    if (!d.endpointPropertyInfo.endpointInfo.endpointName) {
                                        if (d.callerInfo) {
                                            channel.participantId = d.callerInfo;
                                        }
                                    } else {
                                        channel.participantId = d.endpointPropertyInfo.endpointInfo.endpointName;
                                    }
                                }
                                //pcs.endpointModel.addEndpointToChannel(_calls[d.callId].channelId, answeredByEP);
                            } else {
                                channel.participantId = pcs.activeCallOffer.endpointPropertyInfo.endpointInfo.endpointName;
                                pcs.activeCallOffer = null; // Call is connected, clearing activeCallOffer
                            }

                            channel.callActive = true;

                            pcs.createParticipantFilter(channel);
                            feedModel.addChannelFeedEvent(channel.id, 'You', 'call-started', { message: 'Answered a call from '});
                            $rootScope.$broadcast('privateCallService.callConnected', channel);
                        } catch (ex) {
                            $log.error("channel not found on call connected state: " + ex);
                        }
                    }
                    $rootScope.$broadcast('privateCallService.callProgressReceived', d);
                });
            });

            var onCallOfferReceived = this.client.onCallOfferReceived.subscribe((d) => {
                let pcs = this;
                pcs.activeCallOffer = d;
                $rootScope.$applyAsync(function () {
                    // TBD: Revisit when Proxy/Clients fix this. Proxy does not normalize data for us so
                    // when a private call comes from DR2, ADC, Radio we do not get any EndpointInfo. All
                    // we have is the UserName in the callerInfo field. Fortunately that is all that we require
                    if (d.endpointPropertyInfo.endpointInfo.endpointId.length === 0) {
                        d.endpointPropertyInfo.endpointInfo.endpointName = d.callerInfo;

                        let user = userService.getUser(d.callerInfo);
                        if(user) {
                            d.callerInfo = user.displayName;
                        }

                        // Auto-answering non thin client calls. These are treated as barge calls
                        // and will be answered randomly by any client signed in with the same user
                        if(!user || isRadioUser(user)) {
                            pcs.callAnswer(true);
                        } else { // It's ADC or DR2
                            notifyCallofferReceived(d);
                        }
                        $log.debug('Non-thin-client Call Offer Received', d, user);
                    } else {
                        notifyCallofferReceived(d);
                    }

                    // Add an event for when you are receiving a call, even though you might not answer it
                    feedModel.addChannelFeedEvent(0, d.callerInfo, 'call-offer', d);

                });
            });

            var onCallHangupReceived = this.client.onCallHangupReceived.subscribe((d) => {
                let pcs = this;
                $rootScope.$applyAsync(function ($scope) {
                    $log.info('WebComm handling call hangup', d);
                    let call = _calls[d.callId];
                     endCall(call);
                    /*if (call) {
                        feedModel.addChannelFeedEvent(call.channelId, '', 'call-ended', '');
                        call.isActive = false;
                        channelModel.getChannel(call.channelId).callActive = false;
                        pcs.muteService.restoreTempMute();
                        setReadyDisposition(pcs.endpointModel.getMyEndpoint().id);
                    }*/

                    pcs.activeCallOffer = null;
                    $rootScope.$broadcast('privateCallService.callHangupReceived', call);
                });
            });

            var onCallPTTOffReceived = this.client.onCallPTTOffReceived.subscribe((d) => {
                if(d.errorCode > 0) {
                    $rootScope.$applyAsync(function ($scop) {
                        let call = _calls[d.callId];
                        $log.warn('Call PTT forced off', d.errorMessage);
                        $rootScope.$broadcast('privateCallService.callPttOff', call);
                    });
                }
            });

            $rootScope.$on('$destroy', () => {
                onCallHangupReceived();
                onCallOfferReceived();
                onCallProgressRecieved();
                onPhoneLineStatusChanged();
                onCallPTTOffReceived();
                unbindChannelSelected();
                unbindLogout();
                unbindReconnect();
            });

            $log.info("Private Call Service initialized");
        }

        activatePhoneLine(line) {
            var pcs = this;

            if (!pcs.$rootScope.noMicrophone) {
                this.client.setEndpointPropertiesPrivateCallFilter("*")
                    .then((resp) => {
                        this.client.setActivePhoneLines([line])
                            .then((resp) => {
                                pcs.phoneLine.number = line;
                                pcs.phoneLine.status = pcs.activationStatus.Pending;
                                pcs.phoneLine.statusMessage = 'Activating';
                            })
                            .catch((err) => {
                                pcs.$log.error(err);

                                switch (err.errorCode) {
                                    case 25:
                                        pcs.noCallResource = true;
                                        pcs.phoneLine.status = pcs.activationStatus.Error;
                                        pcs.phoneLine.statusMessage = 'No call resource';
                                        break;
                                    case 22:
                                        pcs.invalidPhoneLine = true;
                                        pcs.phoneLine.status = pcs.activationStatus.Error;
                                        pcs.phoneLine.statusMessage = 'Invalid phone line';
                                        break;
                                }
                            });
                    });
            } else {
                pcs.$log.warn('Microphone not enabled, skipping phone line activation');
            }
        }

        getCall(callId) {
            return _calls[callId];
        }

        callRequest(contactNumber, contactUserName, contactName, barge) {
            this.$log.debug(`privateCallService.callRequest to contactNumber: ${contactNumber}, contactUserName: ${contactUserName}`);

            const pcs = this;

            // Someone is calling the client, but we are clicking to call a different user. Hangup on the active call
            // offer before placing call
            if(pcs.activeCallOffer) {
                this.callHangup(pcs.activeCallOffer.callId);
            }

            return pcs.$q(function (resolve, reject) {
                if (pcs.phoneLine.status === pcs.activationStatus.Active) {
                    var callId = pcs.numberCallIdMap[contactNumber];
                    var call = callId ? _calls[callId] : null;
                    if (call && call.isActive) {
                        reject('A call is already active, aborting');
                    }
                    else {
                        // -- Defaults --
                        var callType = 2;
                        var myNumber = pcs.phoneLine.number;
                        var myEndpoint = _endpointModel.getMyEndpoint();

                        // -- Overrides --
                        if (_endpointModel.getEndpoint(contactNumber)) {
                            callType = 1;
                        }

                        if (callType === 1) {
                            myNumber = myEndpoint.id;
                        }

                        pcs.client.makeCall(callType, pcs.phoneLine.number, contactNumber)
                            .then((resp) => {
                                call = new pcs.privateCall(resp.callId, resp.destination);
                                call.channelId = _channelModel.addOrUpdatePrivateCallChannel(callType,
                                    myEndpoint.userName, contactUserName, contactNumber, contactName, resp.callId,
                                    contactUserName, barge);
                                _muteService.tempMuteAll();
                                _channelModel.selectChannel(call.channelId);
                                pcs.activeCall = call;
                                setPhoneDisposition(myEndpoint.id);
                                resolve(call);
                            })
                            .catch((err) => {
                                reject(err);
                            });
                    }
                } else {
                    reject('Your phone line is not active');
                }
            });
        }

        callAnswer(barge) {
            const pcs = this;

            pcs.activeCall = null;

            return pcs.$q(function (resolve, reject) {
                if (pcs.phoneLine.status === pcs.activationStatus.Active) {
                    pcs.client.answerCall(pcs.activeCallOffer.callId)
                        .then((resp) => {
                            let call = new pcs.privateCall(resp.callId, pcs.activeCallOffer.callerId);
                            pcs.activeCall = call;
                            let myEndpoint = _endpointModel.getMyEndpoint();
                            let callerUserName = pcs.activeCallOffer.endpointPropertyInfo.endpointInfo.endpointName;
                            call.channelId = _channelModel.addOrUpdatePrivateCallChannel(
                                pcs.activeCallOffer.callType,
                                myEndpoint.userName,
                                callerUserName,
                                pcs.activeCallOffer.callerId,
                                pcs.activeCallOffer.callerInfo,
                                resp.callId,
                                callerUserName,
                                barge);
                            //pcs.endpointModel.addEndpointToChannel(call.channelId, myEndpoint);
                            //pcs.endpointModel.addEndpointToChannel(call.channelId, callerEndpoint);
                            _muteService.tempMuteAll();
                            setPhoneDisposition(myEndpoint.id);
                            resolve(call);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                } else {
                    reject('Your phone line is not active');
                }
            });
        }

        callHangup(callId) {
            const pcs = this;

            pcs.activeCall = null;
            return pcs.$q(function (resolve, reject) {
                if (pcs.phoneLine.status === pcs.activationStatus.Active) {
                    pcs.client.hangupCall(callId)
                        .then((resp) => {
                            let call = _calls[resp.callId];
                            endCall(call);
                            /*if (call) {
                                pcs.feedModel.addChannelFeedEvent(call.channelId, '', 'call-ended', '');
                                call.isActive = false;
                                _channelModel.getChannel(call.channelId).callActive = false;
                                _muteService.restoreTempMute();
                                setReadyDisposition(_endpointModel.getMyEndpoint().id);
                            }*/

                            pcs.$rootScope.$broadcast('privateCallService.callHangupReceived', call);
                            resolve(resp);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                } else {
                    reject('Your phone line is not active');
                }
            });
        }
    }

    angular
        .module('webcomm')
        .service('privateCallService', [
            '$rootScope',
            '$q',
            '$log',
            '$timeout',
            'wtcpjsClientProviderService',
            'muteService',
            'endpointModel',
            'channelModel',
            'feedModel',
            'dispositionService',
            'userService',
            PrivateCallService]);
})(angular);